<div class="col-sm-12 coldx">
    <div class="col-sm-12 coldx">
      <h4>Annulla documento protocollato</h4>
    </div>
</div>

<form [formGroup]="form">
  <div textInput [control]="form.controls['estremiProvvedimento']" class="col-sm-12"
        [labelInput]="'Estremi del provvedimento di autorizzazione'" formControlName="estremiProvvedimento" [mandatory]="true"></div>

  <div datePickerInput class="col-sm-6" [labelInput]="'Data di annullamento'" formControlName="dataAnnullamento"
        [control]="form.controls['dataAnnullamento']"
        [mandatory]="true">
  </div>
  <div class="col-sm-6">
    <p>
      <label for="identificativoOperatore">Identificativo operatore</label> <input  id="identificativoOperatore" name="identificativoOperatore" class="form-control"
        [value]="currentOperator" type="text" disabled>
    </p>
  </div>

   <div class="standardpanel">
    <div class="row">
      <div class="col-xs-6 col-sm-4">
         <button type="button" role="button" class="btn btn-secondary btn-block" (click)="annulla()">Annulla</button>
      </div>
      <div class="col-xs-6 col-sm-4 col-sm-offset-4">
        <button type="button" role="button" class="btn btn-primary btn-block" (click)="conferma()" [disabled]="form.invalid">Conferma</button>
      </div>
    </div>
  </div>
</form>

